import { axiosInstance } from '../../axios';

export const getDataCountsApi = async (id) => {
  const response = await axiosInstance.post(
    process.env.REACT_APP_GET_ALL_COUNTS
  );

  return response.data;
};
